import React from 'react';
import '../../App.css';
import LandlordCards from '../LandlordCards';
import HeroSection from '../HeroSection';

function Landlord () {
    return(
        <>
        <div class="hero-container">
			<div class="container">
				<div class="row">
					<div class="col-md-4">
						<h2 class=" subheader36 green-text">List your space and start making money</h2>
						<br/><br/>
						<a class="partner-btn" href="/partner"> Get Started</a>
						
					</div>
					<div class="col-md-2"></div>
					<div class="col-md-6">
						<img id="test" alt="Teamwork" src="images/landlord pic.png"/>
					</div>
					<br/><br/><br/><br/>
				</div>
			</div>
		</div>
        <LandlordCards />
        <br />
        </>
    );
    
}

export default Landlord;